// define an action in Redux is to separately declare an action type
export const customersAction = (incomingType, incomingValue) => {
  return {
    type: incomingType,
    payload: incomingValue,
  }
}
